import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private translations = {
    maintenance: $localize`:@@title.maintenance:Vzdrževanje`,
    notifications: $localize`:@@title.notifications:Obvestila`,
    login: $localize`:@@title.login:Prijava`,
    register: $localize`:@@title.register:Registracija`,
    tryDemo: $localize`:@@title.try-demo:Preizkusi demo`,
    demoCode: $localize`:@@title.demo-code:Prijava z demo kodo`,
    keycloakCallback: $localize`:@@title.keycloak-callback:Prijava`,
    mobilePackages: $localize`:@@title.mobile-packages:Izbira paketa`,
    companionUpgrade: $localize`:@@title.companion-upgrade:Nadgradnja paketa`,
    forgotPassword: $localize`:@@title.forgot-password:Pozabljeno geslo`,
    resetPassword: $localize`:@@title.reset-password:Ponastavi geslo`,
    logout: $localize`:@@title.logout:Odjava`,
    pageNotFound: $localize`:@@title.page-not-found:Stran ne obstaja`,
    vehicleListing: $localize`:@@title.vehicle-listing:Vozilo`,
    vehicleListingList: $localize`:@@title.vehicle-listing:Vozila`,
    vehicleListingsForDealer: $localize`:@@title.vehicle-listings-for-dealer:Vsa vozila`,
    userDashboard: $localize`:@@title.userDashboard:Namizje`,
    dashboard: $localize`:@@title.dashboard:Nadzorna plošča`,
    businessOverview: $localize`:@@title.businessOverview:Pregled poslovanja`,
    entityWorkflowForm: $localize`:@@title.entity-workflow-form:Voden vnos podatkov`,
    entityWorkflowResult: $localize`:@@title.entity-workflow-result:Pregled vodenega vnosa podatkov`,
    virtualSalonSettings: $localize`:@@title.virtual-salon-settings:Spletna stran`,
    virtualSalonEmbed: $localize`:@@title.virtual-salon-embed:Koda za vgradnjo`,
    virtualSalonDomainSettings: $localize`:@@title.virtual-salon-domain-settings:Poddomena`,
    virtualSalonReport: $localize`:@@title.virtual-salon-report:Poročilo`,
    administrationSettings: $localize`:@@title.administration-settings:Administracija`,
    providers: $localize`:@@title.financing-providers:Ponudniki financiranj`,
    financingList: $localize`:@@title.financing-list:Financiranja`,
    financingListCompleted: $localize`:@@title.financing-completed:Zaključena financiranja`,
    financingListPending: $localize`:@@title.financing-pending:Financiranja v obdelavi`,
    providersLeanpay: $localize`:@@title.financing-providers.leanpay:Leanpay financiranje`,
    testPlatesSettings: $localize`:@@title.test-plates-settings:Preizkusne tablice`,
    adIntegrationsSettings: $localize`:@@ttitle.integrations-settings:Integracije`,
    // The ad-integrations + integrations-ad-card-settings routes both pass
    // `title.advertisingSettings`; without an entry here the title strategy
    // logged a warning and rendered the raw key in the browser tab.
    advertisingSettings: $localize`:@@title.advertising-settings:Oglaševanje`,
    carpeakSettings: $localize`:@@title.carpeak-settings:CarPeak`,
    packagesPage: $localize`:@@title.packagesPage:Produktni Paketi`,
    rolesPage: $localize`:@@title.packagesPage:Vloge`,
    addikoOffer: $localize`:@@title.addikoOffer:Addiko Ponudba`,
    addikoForm: $localize`:@@title.addikoForm:Addiko Vloga`,
    addikoCalculation: $localize`:@@title.addikoCalculation:Addiko Izračun`,

    vehicles: $localize`:@@title.vehicles:Vozila`,
    vehiclesAll: $localize`:@@title.vehicles:Vsa Vozila`,
    vehiclesArchived: $localize`:@@title.vehicles:Arhivirana Vozila`,
    vehiclesAd: $localize`:@@title.vehicles:Oglaševana vozila`,
    vehicle: $localize`:@@title.vehicle:Vozilo`,
    addVehicle: $localize`:@@title.add-vehicle:Dodajanje vozila`,
    editVehicle: $localize`:@@title.edit-vehicle:Urejanje vozila`,
    vehiclesImported: $localize`:@@title.vehicles-imported:Uvoz vozila`,
    printVehicle: $localize`:@@title.print-vehicle:Tiskanje podatkov`,
    processFormVehicle: $localize`:@@title.process-form-vehicle:Procesni način`,
    vehicleWorkflows: $localize`:@@title.vehicle-workflows:Vodeni vnosi podatkov`,
    vehicleMarketStudies: $localize`:@@title.vehicle-market-studies:Analiza trga`,
    vehicleAds: $localize`:@@title.vehicle-ads:Oglaševanje`,
    vehicleFiles: $localize`:@@title.vehicle-files:Datoteke`,
    vehicleDocuments: $localize`:@@title.vehicle-documents:Dokumenti`,
    // The vehicle detail page's "Arhiv" tab routes to `title.vehicleArchive`;
    // without an entry here the raw key rendered in the browser tab as
    // "vehicleArchive | Briefd".
    vehicleArchive: $localize`:@@title.vehicle-archive:Arhiv dokumentov`,
    // The Design 2.0 detail page renamed these four tabs but the routes kept
    // their legacy titles, so the browser tab said "Stroški" while the open tab
    // said "Nabava" (and the URL said `expenditures`). Titles now track what the
    // dealer actually sees.
    vehicleEquipment: $localize`:@@title.vehicle-equipment:Oprema`,
    vehiclePhotos: $localize`:@@title.vehicle-photos:Fotografije`,
    vehiclePurchasing: $localize`:@@title.vehicle-purchasing:Nabava`,
    vehicleSales: $localize`:@@title.vehicle-sales:Prodaja`,
    clientDocuments: $localize`:@@title.client-documents:Dokumenti`,
    vehicleWarranty: $localize`:@@title.vehicle-warranty:Jamstva`,
    vehicleExpenditures: $localize`:@@title.vehicle-expenditures:Stroški`,
    editIntegrationVehicleAd: $localize`:@@title.vehicle-ad-form:Obrazec za oglas vozila`,

    leasings: $localize`:@@title.vehicle-financing:Financiranja`,
    leasingForm: $localize`:@@title.vehicle-leasing-form:Obrazec za izdajo leasinga`,
    leasingSuccess: $localize`:@@title.vehicle-leasing-success:Uspešno oddano financiranje`,

    warranties: $localize`:@@title.warranties:Jamstva`,

    documents: $localize`:@@title.documents:Izdani dokument`,
    availableDocuments: $localize`:@@title.documents:Izdaj dokument`,
    documentCreationSuccess: $localize`:@@title.document-creation-success:Dokument uspešno ustvarjen`,

    marketStudy: $localize`:@@title.market-study:Valuacija`,

    clients: $localize`:@@title.clients:Imenik`,
    entityRelationships: $localize`:@@title.entity-relationships:Povezave`,

    partners: $localize`:@@title.partners:Partnerji`,
    transporters: $localize`:@@title.transporters:Prevozniki`,
    suppliers: $localize`:@@title.suppliers:Dobavitelji`,
    customers: $localize`:@@title.customers:Stranke`,
    'authorized-services': $localize`:@@title.authorized-services:Pooblaščeni servisi`,

    client: $localize`:@@title.client:Imenik`,
    addClient: $localize`:@@title.add-client:Dodajanje kontakta`,
    editClient: $localize`:@@title.edit-client:Urejanje kontakta`,
    clientWorkflows: $localize`:@@title.client-workflows:Vodeni vnosi podatkov`,
    clientConsents: $localize`:@@title.client-consents:Soglasja`,
    clientAlarms: $localize`:@@title.client-alarms:Opomniki`,
    clientFiles: $localize`:@@title.client-files:Datoteke`,
    clientInvoices: $localize`:@@title.client-invoices-archive:Arhiv računov`,
    clientLeasings: $localize`:@@title.client-financing-archive:Arhiv financiranj`,

    userProfile: $localize`:@@title.user-profile:Profil uporabnika`,
    paymentMethod: $localize`:@@title.payment-method:Način plačila`,
    accountProfile: $localize`:@@title.account-profile:Profil podjetja`,
    manageUsers: $localize`:@@title.manage-users:Uporabniki`,

    administration: $localize`:@@title.administration:Administracija`,
    b2bInvoices: $localize`:@@title.b2bInvoices:Vhodni E-računi`,
    b2bInvoicePreview: $localize`:@@title.b2bInvoicePreview:E-račun`,

    nonimported: $localize`:@@title.imported.nonimported:Prenešeno`,
    imported: $localize`:@@title.imported.imported:Na zalogi`,

    total: $localize`:@@title.total:Skupaj`,
    assets: $localize`:@@title.assets:Blago & Storitve`,

    excelImport: $localize`:@@title.excel:Excel`,
    browserExtension: $localize`:@@title.browser-extension:Vtičnik v brskalniku`,
    tradingHub: $localize`:@@title.tradingHub:Trading Hub`,
    tradingHubAdmin: $localize`:@@title.tradingHub:Trading Hub Admin`,
    tradingHubVehicles: $localize`:@@title.tradingHub:Trading Hub vozila`,
    tradingHubImportForm: $localize`:@@title.tradingHub:Trading Hub obrazec za uvoz`,

    inArrival: $localize`:@@title.in-arrival:V prihodu`,
    inCollection: $localize`:@@title.in-collection:V prevzemu`,
    inTransit: $localize`:@@title.in-transit:V dostavi`,
    delivered: $localize`:@@title.delivered:Dostavljeno`,
    preparingDocumentation: $localize`:@@title.preparing-documentation:Priprava dokumentacije`,
    awaitingPayment: $localize`:@@title.awaiting-payment:Čaka na plačilo`,
    paid: $localize`:@@title.paid:Plačano`,

    successfulExtensionLogin: $localize`:@@title.successfull-extension-login:Uspešna prijava v vtičnik`,
    quickEntryNotInstalledTitle: $localize`:@@quick-entry.dialog.not-installed.title:Namestite QuickEntry za hitrejši vnos vozil`,
    quickEntryNotInstalledBody: $localize`:@@quick-entry.dialog.not-installed.body:QuickEntry je razširitev za brskalnik, ki vam omogoča hiter zajem in urejanje podatkov o vozilih ter zmanjša čas ročnega vnosa. Namestite jo, če želite pospešiti svoje delo.`,
    quickEntryLoggedOutTitle: $localize`:@@quick-entry.dialog.logged-out.title:QuickEntry ni prijavljen`,
    quickEntryLoggedOutBody: $localize`:@@quick-entry.dialog.logged-out.body:Razširitev QuickEntry je nameščena, vendar niste prijavljeni vanjo. Dokler se ne prijavite, je ne morete uporabljati.`,
    quickEntryGoToConfig: $localize`:@@quick-entry.dialog.go-to-config:Nastavitve QuickEntry`,
    quickEntryLogin: $localize`:@@quick-entry.dialog.login:Prijava`,
    quickEntryDontRemindAgain: $localize`:@@quick-entry.dialog.dont-remind-again:Ne opozarjaj me več`,
    quickEntryClose: $localize`:@@quick-entry.dialog.close:Zapri`,
    quickEntryStatusChecking: $localize`:@@quick-entry.status.checking:Preverjanje stanja QuickEntry ...`,
    quickEntryStatusInstalledLoggedIn: $localize`:@@quick-entry.status.installed-logged-in:QuickEntry je nameščen in prijavljen.`,
    quickEntryStatusInstalledLoggedOut: $localize`:@@quick-entry.status.installed-logged-out:QuickEntry je nameščen, vendar niste prijavljeni.`,
    quickEntryStatusNotInstalled: $localize`:@@quick-entry.status.not-installed:QuickEntry še ni nameščen.`,
    purchaseVehicle: $localize`:@@vehicle-menu.purchase-vehicle:Nakup vozila`,
    auctionVehicle: $localize`:@@vehicle-menu.bids:Dražbe vozil`,

    inProgress: $localize`:@@title.in-progress:V teku`,
    finished: $localize`:@@title.finished:Zaključena`,
    cancelled: $localize`:@@title.cancelled:Preklicano`,
    pending: $localize`:@@title.pending:V obdelavi`,
    validating: $localize`:@@title.validating:Potrjevanje`,
    blocked: $localize`:@@title.blocked:Blokirano`,
    unknownStatus: $localize`:@@title.unknown-status:Neznano stanje`,

    // Backfill — every route key passed via `title: 'title.<key>'` must have a
    // matching entry here; missing ones surface as raw English-looking
    // identifiers in the browser tab (the user is in the SLO design review for
    // BRIEFD-6635 — "Oglaševanje / everything is in English" was largely this).
    addVehicleQuick: $localize`:@@title.add-vehicle-quick:Hitri vnos vozila`,
    addWorkOrderItem: $localize`:@@title.add-work-order-item:Dodajanje opravila`,
    administrationKontosSettings: $localize`:@@title.administration-kontos-settings:Konti`,
    advertising: $localize`:@@title.advertising:Oglaševanje`,
    analytics: $localize`:@@title.analytics:Analitika`,
    businessUnit: $localize`:@@title.business-unit:Poslovna enota`,
    businessUnitSettings: $localize`:@@title.business-unit-settings:Nastavitve poslovne enote`,
    businessUnitsSettings: $localize`:@@title.business-units-settings:Poslovne enote`,
    createAdministrationDocument: $localize`:@@title.create-administration-document:Izdaja dokumenta`,
    createVehicleByVin: $localize`:@@title.create-vehicle-by-vin:Vnos vozila po VIN`,
    eInvoicePreview: $localize`:@@title.e-invoice-preview:E-račun`,
    eInvoices: $localize`:@@title.e-invoices:E-računi`,
    editWorkOrderItem: $localize`:@@title.edit-work-order-item:Urejanje opravila`,
    fiscalizationSettings: $localize`:@@title.fiscalization-settings:Fiskalizacija`,
    help: $localize`:@@title.help:Pomoč`,
    listWarranties: $localize`:@@title.list-warranties:Jamstva`,
    packages: $localize`:@@title.packages:Paketi`,
    pageDeactivated: $localize`:@@title.page-deactivated:Stran je onemogočena`,
    planTargets: $localize`:@@title.plan-targets:Načrt prodaje`,
    providersNLB: $localize`:@@title.providers-nlb:NLB financiranje`,
    publishFormVehicle: $localize`:@@title.publish-form-vehicle:Objava oglasa`,
    vehicleActivity: $localize`:@@title.vehicle-activity:Aktivnosti vozila`,
    damageInspectionReport: $localize`:@@title.damage-inspection-report:Poročilo o škodi`,
    vehicleBidding: $localize`:@@title.vehicle-bidding:Dražba`,
    vehicleLeasing: $localize`:@@title.vehicle-leasing:Financiranje`,
    vehiclesValuation: $localize`:@@title.vehicles-valuation:Valuacija vozil`,
    workOrderItems: $localize`:@@title.work-order-items:Opravila delovnih nalogov`,
  };

  getTranslation(prop: string) {
    if (!this.translations[prop]) {
      console.warn(`Translation for ${prop} is not defined in translation service.`);
    }

    return this.translations[prop] ?? prop;
  }
}
